import cx from "@hsl/core/utils/cx";

const KeyDocumentsHeader = ({
    className,
    children,
}: {
    className?: string;
    children: React.ReactNode;
}) => (
    <h4
        className={cx(
            "border-b-2 border-gray-300 pb-1 text-sm font-medium",
            className,
        )}
    >
        {children}
    </h4>
);

export default KeyDocumentsHeader;
